// Componente principal da página de convite
import * as React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import PasswordOperation from '../PasswordOperation/PasswordOperation';

const Invitation: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Extrair parâmetros da URL do convite
  const token = searchParams.get('token');
  const email = searchParams.get('email');

  // Validar se todos os parâmetros necessários estão presentes
  if (!token || !email) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f3f2f1'
      }}>
        <div style={{
          textAlign: 'center',
          padding: '2rem',
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          maxWidth: '400px'
        }}>
          <h2 style={{ color: '#d13438', marginBottom: '1rem' }}>Convite Inválido</h2>
          <p style={{ marginBottom: '1.5rem', color: '#605e5c' }}>
            Este link de convite é inválido ou está incompleto.
            Verifique se você copiou o link completo do email.
          </p>
          <button
            onClick={() => navigate('/login')}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#0078d4',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            Ir para Login
          </button>
        </div>
      </div>
    );
  }

  return <PasswordOperation params={{ type: 'invitation', email, token }} />;
};

export default Invitation;